import * as Yup from "yup";

export const CreateDiscussionTopic = Yup.object().shape({
	title: Yup.string().required("Title is required"),
	topic_category_id: Yup.string().required("Topic category is required").nullable(),
	province_ids: Yup.array(),
	batch: Yup.array(),
});
